import React from 'react';
import { Col, Text } from 'rsuite';
import { convertNumberToCurrency } from '../../../common/utils';

const ProviderValues = ({
    sortedLicenses,
    keyPrefix,
    valueGetter,
    bold,
    xsRowValueWidth,
    mdRowValueWidth
}) => (
    <>
        {
            sortedLicenses.map((provider, index) => (
                <Col key={`${keyPrefix}_${index}`} xs={xsRowValueWidth} md={mdRowValueWidth}>
                    <Text className={bold ? "text-bold" : ""} align="right">{convertNumberToCurrency(valueGetter(provider) ?? '-')}</Text>
                </Col>
            ))
        }
    </>
);

export default ProviderValues;